// removed by extract-text-webpack-plugin
module.exports = {"headerBar":"index__headerBar___19f5X"};


//////////////////
// WEBPACK FOOTER
// ./src/header/index.scss
// module id = ./src/header/index.scss
// module chunks = 1